import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

// Register the necessary Chart.js elements
ChartJS.register(ArcElement, Tooltip, Legend);

const DevelopmentStrategiesSection = () => {
  // Data for the pie chart
  const data = {
    labels: [
      'مفاهيم ومعارف',
      'استبيانات قياس مهارات',
      'أوراق عمل وتخطيط شخصي',
      'أنشطة تطبيقية ومهام تعاونية',
    ],
    datasets: [
      {
        data: [30, 15, 20, 35], // Percentage values for the pie chart
        backgroundColor: ['#e6c6c6', '#d09d9d', '#b45f5f', '#7e3535'],
        borderColor: '#fff',
        borderWidth: 1,
      },
    ],
  };

  // Options for the pie chart
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
    },
  };

  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
         <div className="grid place-items-center my-4">
      <p className="services-header flex justify-center after:w-32 after:-bottom-2">
      نسبة استراتيجية التطوير من المحتوى
      </p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row-reverse', justifyContent: 'space-between', flexWrap: 'wrap',alignItems: 'center' }} className='row justify-content-between align-items-center'>
        <div style={{  marginBottom: '20px',border: '1px solid #D9D9D9',borderRadius: '12px'}} className='col-md-6 '>
          <Pie data={data} options={options} style={{
            margin: ' 0 auto',
            width: '250px',
            height: '250px',
          }} className=''/>
        </div>
        <div style={{ marginBottom: '20px' }} className='row justify-content-between align-items-center col-md-5'>
          <div style={{ marginBottom: '30px',border: '1px solid #D9D9D9',borderRadius: '12px', }} className='col-md-5 position-relative'>
            <p style={{ fontWeight: 'bold' }} className='size-12 flex justify-center items-center rounded-full border-2 border-secondary-tw bg-secondary-tw    z-10   absolute -top-5 text-white' >15%</p>

            <p className='mt-4'>استبيانات قياس مهارات</p>
          </div>
          <div style={{ marginBottom: '30px',border: '1px solid #D9D9D9',borderRadius: '12px', }}  className='col-md-5 position-relative'>
          <p style={{ fontWeight: 'bold' }} className='size-12 flex justify-center items-center rounded-full border-2 border-secondary-tw bg-secondary-tw    z-10   absolute -top-5 text-white' >30%</p>
            <p className='mt-4'>مفاهيم ومعارف</p>
          </div>
          <div style={{ marginBottom: '30px' ,border: '1px solid #D9D9D9',borderRadius: '12px',}}  className='col-md-5 position-relative'>
          <p style={{ fontWeight: 'bold' }} className='size-12 flex justify-center items-center rounded-full border-2 border-secondary-tw bg-secondary-tw    z-10   absolute -top-5 text-white' >20%</p>
            <p className='mt-4'>أوراق عمل وتخطيط شخصي</p>
          </div>
          <div style={{ marginBottom: '30px',border: '1px solid #D9D9D9',borderRadius: '12px', }}  className='col-md-5 position-relative'>
          <p style={{ fontWeight: 'bold' }} className='size-12 flex justify-center items-center rounded-full border-2 border-secondary-tw bg-secondary-tw    z-10   absolute -top-5 text-white' >35%</p>
            <p className='mt-4'>أنشطة تطبيقية ومهام تعاونية</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DevelopmentStrategiesSection;
